import BaseCollection from "lib/collection";
import SchemaModel from "models/schema";
import { getStore } from "store";

export default BaseCollection.extend({
    indexes: ["__ref"],
    model: function (attrs, options) {
        const Model = options.collection.getSchemaModel();
        return new Model(attrs, options);
    },

    getSchemaModel: function () {
        const state = getStore().getState();
        const schemaIds = state.schemas.result;
        const schemas = state.entities.schemas;
        const orderSchemaId = schemaIds.find((schemaId) => {
            return schemas[schemaId].type === "order";
        });
        const orderRecord = schemas[orderSchemaId].toJS();
        const orderSchema = new SchemaModel(orderRecord);
        return orderSchema.getModel("line_items");
    },

    isModel: function (model) {
        return model instanceof this.getSchemaModel();
    },
});
